enum VACANCIES {
	VACANCIES = '/api/careerCenter/vacancies',
	VACANCY_BY_ID = '/api/careerCenter/vacancies/',
	VACANCIES_BY_IDS = '/api/careerCenter/vacancies/',
	APPLICANT_BY_STUDENT_ID = '/api/careerCenter/vacancies/applicants/',
	APPLICATION_STATUS_BY_ID = '/api/careerCenter/applications/'
}

enum EMPLOYERS {
	EMPLOYERS = '/api/careerCenter/employers',
	EMPLOYER_BY_ID = '/api/careerCenter/employers/',
	EMPLOYERS_BY_IDS = '/api/careerCenter/employers/'
}

enum EVENTS {
	EVENTS = '/api/careerCenter/events',
	EVENT_BY_ID = '/api/careerCenter/events/',
	EVENTS_BY_IDS = '/api/careerCenter/events/',
	REGISTRANT_BY_STUDENT_ID = '/api/careerCenter/events/registrants/',
	REGISTRATION_ATTENDANCE = '/api/careerCenter/events/registrations/',
	REGISTRATION_STATUS = '/api/careerCenter/events/registrations/'
}

enum REPORTS {
	EFFECTIVENESS = '/api/careerCenter/reports/effectiveness',
	EMPLOYMENT = '/api/careerCenter/reports/employment',
	ENGAGEMENT = '/api/careerCenter/reports/engagement'
}

export default {
	VACANCIES,
	EMPLOYERS,
	EVENTS,
	REPORTS
};
